module.exports = __webpack_public_path__ + "static/media/warrning.3183ba31.svg";